import * as React from 'react';
import { createContext, useContext } from 'react';

import { useExperiment } from '@coursera-web/statsig';

const EXPERIMENT_NAME = 'two_panel_search';
const PARAM_NAME = 'enable_search_ai';

const TwoPanelSearchExperimentContext = createContext(false);

export const useTwoPanelSearchExperiment = () => useContext(TwoPanelSearchExperimentContext);

function TwoPanelSearchExperimentProvider({ children }: React.PropsWithChildren) {
  const experiment = useExperiment(EXPERIMENT_NAME);
  const isTwoPanelSearchEnabled = experiment.get(PARAM_NAME, false);

  return (
    <TwoPanelSearchExperimentContext.Provider value={isTwoPanelSearchEnabled}>
      {children}
    </TwoPanelSearchExperimentContext.Provider>
  );
}

export default TwoPanelSearchExperimentProvider;
